import { useState } from "react";
import { Button, Label } from "expano-components";
import SupplierBatchNumberModal from "./components/Modal";

export const SupplierBatchNumber = ({ data }) => {
  const [isModalOpen, setModalOpen] = useState(false);

  if (!data?.requires_supplier_batch_number_on_delivery) {
    return null;
  }

  if (data.supplier_batch_number) {
    return (
      <p className="text-info">
        Numer partii: {data.supplier_batch_number}
      </p>
    );
  }

  return (
    <div className="m-t-5">
      <Label type="fill" color="#fd397a" text="Brak numeru partii" />
      <br />
      <button onClick={() => setModalOpen(true)} className="btn btn-sm btn-blue">
        <span>Dodaj numer partii</span>
      </button>
      {isModalOpen && (
        <SupplierBatchNumberModal
          grnLineId={data.id}
          initialValues={{
            supplier_batch_number: data.supplier_batch_number || "",
          }}
          handleClose={() => setModalOpen(false)}
        />
      )}
    </div>
  );
};

export default SupplierBatchNumber;
